module.exports = __webpack_public_path__ + "img/2_195.082db059.png";